import SideBar from "../Components/SideBar";
import React, { useEffect, useState } from "react";
import SaveButton, { RemoveButton } from "../Components/AdminButtons";
import IsActive from "../Components/AdminisActive";
import MediaPicker from "../Components/mediaPicker";

import callHomeApi from "../callApi/home";
import DigitalAds from "../Components/home/DigitalAds";
import Influencer from "../Components/home/InfluencerCollab";
import { Section2 } from "../Components/home/Section2";
import Section1 from "../Components/home/Section1";
import { HowToUse } from "../Components/home/HowToUse";
import { Testimonials } from "../Components/home/Testimonials";

export default function AdminHome() {

  const [apiCalled, setApiCalled] = useState(false);
  useEffect(() => {
    callHomeApi().then((res) => {
      setApiCalled(true);
    });
  });

  return (
    <>
    {apiCalled? (
    <div className="admin-home">
      <SideBar />
      <div className="admin-container">
        <Section1/>
        <Section2/>
        <HowToUse/>
        <DigitalAds/>
        <Influencer/>
        <Testimonials/>
      </div>
    </div>
    ):null}</>
  );
}
